export const filterOnlyNumber = (value: string) => {
  return value.replace(/[^0-9]/g, '');
};

export const filterNumberWithHyphen = (value: string) => {
  return value.replace(/[^0-9-]/g, '');
};
